
import React, {useCallback} from "react";
import { SaveButton, Toolbar, useCreate, useRedirect, useNotify } from "react-admin";
import { useForm } from 'react-final-form';

const CustomSave = ({ handleSubmitWithRedirect, resource, ...props }) => {
    const [create] = useCreate(resource);
    const redirectTo = useRedirect();
    const notify = useNotify();
    const { basePath } = props;
    const form = useForm();

    const handleClick = useCallback(() => {
        const values = {...form.getState().values};
        const skuCode = values.sku_code;
        values.sku_code = Array.isArray(skuCode)
            ? skuCode.map((item) => String(item).trim()).filter(Boolean)
            : String(skuCode || "").split(",").map((item) => item.trim()).filter(Boolean);
        values.material = (values.material || []).map((item) =>
            item && typeof item === "object" ? item.value ?? item.name : item
        );

        create(
            {
                payload: { data: { ...values } },
            },
            {
                onSuccess: ({ data }) => {
                    notify(data.message, 2000);
                    redirectTo(basePath);
                },
                onFailure: ({response: {data: {errors}}}) => {
                    const message = errors[Object.keys(errors)[0]][0];
                    notify(message, 2000);
                },
            }
        );

    }, [form, basePath, create, notify, redirectTo]);

    return <SaveButton {...props} handleSubmitWithRedirect={handleClick} disabled={form.getState().hasValidationErrors} />;
};

export const CreateMaterialToolbar = props => (
    <Toolbar {...props}>
        <CustomSave
            redirect="list"
            submitOnEnter={false}
            variant="text"
        />
    </Toolbar>
);



export const MaterialResources = 'material-data'
